import { render, staticRenderFns } from "./quotationsList.vue?vue&type=template&id=59d24d03&scoped=true&"
import script from "./quotationsList.vue?vue&type=script&lang=js&"
export * from "./quotationsList.vue?vue&type=script&lang=js&"
import style0 from "./quotationsList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./quotationsList.vue?vue&type=style&index=1&id=59d24d03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d24d03",
  null
  
)

export default component.exports